export * from './get-comparison-query-variable';
